<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="100px" :model="form">
      <el-row>
        <el-form-item label="联系人" style="margin-right:15px">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="手机号" style="margin-right:15px">
          <el-input v-model="form.phone" :disabled="true" />
        </el-form-item>
        <el-form-item label="加油站名称" style="margin-right:15px">
          <el-input v-model="form.gasName" :disabled="true" />
        </el-form-item>
        <el-form-item label="加油站地址" style="margin-right:15px">
          <el-input v-model="form.addressDetail" :disabled="true" />
        </el-form-item>
        <el-form-item label="创建时间" style="margin-right:15px">
          <el-input v-model="form.gmtCreated" :disabled="true" />
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'GasStationDetail',
        data() {
            return {
                emptyForm: {},
                form: {
                    gasBalance: '',
                    name: '',
                    paytyCode: '',
                    gasName: '',
                    branchCode: '',
                    startGmtCreated: "",
                    gmtCreated:'',
                    endGmtCreated: "",
                    addressDetail: '',
                }
            }
        },
        created() {
            //保存空表单对象
            this.emptyForm = JSON.parse(JSON.stringify(this.form))
        },
        methods: {
            // 获取页面信息
            getInfo(code) {
                //查询到数据之前先展示空表单
                this.form = JSON.parse(JSON.stringify(this.emptyForm))
                request({url: `/ntocc-basic-api/gasStation/${code}`, method: 'get'}).then(response => {
                    this.form = response.data
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
